import { render, staticRenderFns } from "./GroupsTable.vue?vue&type=template&id=75951216&scoped=true"
import script from "./GroupsTable.vue?vue&type=script&lang=js"
export * from "./GroupsTable.vue?vue&type=script&lang=js"
import style0 from "./GroupsTable.vue?vue&type=style&index=0&id=75951216&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75951216",
  null
  
)

export default component.exports